import { cannotLeaveGapsBetweenSelectedSeatsRule, cannotLeaveSingleSeatGapFromAisleRule, cannotLeaveSingleSeatGapFromUnavailableSeatRule, mustFillSofaSeatsRule, mustRespectSeatSelectionLimitsRule, mustSelectAssociatedWheelchairSeatRule, validateSeatingDataAgainstSeatSelectionRules } from '@vista/omnichannel-components-domain';
import { getSeatSelectionRuleViolationErrorMessage } from '../mappers/seat-picker-error-message-mapper';
export const validateSeatSelections = (config, displayText, data, selectedSeats) => {
    const rules = getEnabledRulesForConfig(config);
    const validationResult = validateSeatingDataAgainstSeatSelectionRules(rules, data, selectedSeats);
    return {
        isValid: validationResult.isValid,
        violatedRules: validationResult.violatedRules.map(ruleName => {
            return {
                name: ruleName,
                message: getSeatSelectionRuleViolationErrorMessage(ruleName, selectedSeats.length, displayText)
            };
        })
    };
};
const getEnabledRulesForConfig = (config) => {
    const rules = [];
    if (config.cannotLeaveGapsBetweenSelectedSeats.enabled) {
        rules.push(cannotLeaveGapsBetweenSelectedSeatsRule(config.cannotLeaveGapsBetweenSelectedSeats.options));
    }
    if (config.cannotLeaveSingleSeatGapFromAisle.enabled) {
        rules.push(cannotLeaveSingleSeatGapFromAisleRule(config.cannotLeaveSingleSeatGapFromAisle.options));
    }
    if (config.cannotLeaveSingleSeatGapFromUnavailableSeat.enabled) {
        rules.push(cannotLeaveSingleSeatGapFromUnavailableSeatRule(config.cannotLeaveSingleSeatGapFromUnavailableSeat.options));
    }
    if (config.mustFillSofaSeats.enabled)
        rules.push(mustFillSofaSeatsRule(config.mustFillSofaSeats.options));
    if (config.mustRespectSeatSelectionLimits.enabled)
        rules.push(mustRespectSeatSelectionLimitsRule());
    if (config.mustSelectAssociatedWheelchairSeat.enabled)
        rules.push(mustSelectAssociatedWheelchairSeatRule());
    return rules;
};
